module.exports = __webpack_public_path__ + "img/moon-stars.55644ae2.svg";